import axios from "axios";
import { portSubdomainMap, rootDomain } from "./globalMetaData";

const baseName = process.env.REACT_APP_KHELUNJITUN_APIURL;

const axiosInstance = axios.create({
	baseURL: baseName,
	headers: { "Content-Type": "application/json" },
});

function getBaseURL(port) {
	const subdomain = portSubdomainMap[port];
	if (!subdomain) {
		console.error(`No subdomain mapped for port ${port}`);
	}
	return `https://${subdomain}.${rootDomain}`;
}

export async function generalPostFunction(endpoint, payload, port) {
	const axiosInstance = axios.create({
		baseURL: getBaseURL(port),
		headers: { "Content-Type": "application/json" },
	});

	return axiosInstance
		.post(`${endpoint}`, payload)
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function generalGetFunction(endpoint, port) {
	const axiosInstance = axios.create({
		baseURL: getBaseURL(port),
		headers: { "Content-Type": "application/json" },
	});

	return axiosInstance
		.get(`${endpoint}`)
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			return err;
		});
}

export async function generalPatchFunction(endpoint, payload, port) {
	const axiosInstance = axios.create({
		baseURL: getBaseURL(port),
		headers: { "Content-Type": "application/json" },
	});

	return axiosInstance
		.patch(`${endpoint}`, payload)
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			return err;
		});
}

export function getFinalTime(secondsToAdd) {
	const now = new Date();
	const finalTime = new Date(now.getTime() + secondsToAdd * 1000);

	let hours = finalTime.getHours();
	const minutes = String(finalTime.getMinutes()).padStart(2, "0");
	const seconds = String(finalTime.getSeconds()).padStart(2, "0");

	const ampm = hours >= 12 ? "PM" : "AM";
	hours = hours % 12;
	hours = hours ? hours : 12; // the hour '0' should be '12'
	hours = String(hours).padStart(2, "0");

	return `${hours}:${minutes} ${ampm}`;
}

export function convertTimeToAMPM(timestring) {
	if (!timestring) return "";

	const [hours, minutes, seconds] = timestring.split(":").map(Number);

	let period = "AM";
	let hour = hours;

	if (hours === 0) {
		hour = 12;
	} else if (hours === 12) {
		period = "PM";
	} else if (hours > 12) {
		hour = hours - 12;
		period = "PM";
	}

	// Pad minutes and seconds if needed
	const paddedMinutes = minutes.toString().padStart(2, "0");
	const paddedSeconds = seconds.toString().padStart(2, "0");

	return `${hour}:${paddedMinutes}:${paddedSeconds} ${period}`;
}

export const hasAccess = (account, requiredLevel) => {
	if (!account) return false;
	return account.level <= requiredLevel;
};

export const formatDateLocal = (date) => {
	const pad = (n) => n.toString().padStart(2, "0");

	const year = date.getFullYear();
	const month = pad(date.getMonth() + 1); // months are 0-indexed
	const day = pad(date.getDate());
	const hours = pad(date.getHours());
	const minutes = pad(date.getMinutes());
	const seconds = pad(date.getSeconds());

	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const formatDateLocalNoTime = (date) => {
	const pad = (n) => n.toString().padStart(2, "0");

	const year = date.getFullYear();
	const month = pad(date.getMonth() + 1); // months are 0-indexed
	const day = pad(date.getDate());

	return `${year}-${month}-${day}`;
};
